import React, { useState } from "react";
import IconButton from "@mui/material/IconButton";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import Tooltip from "@mui/material/Tooltip";

export interface CopyToClipboardIconButtonProps {
  value: string;
  label?: string;
  sx?: object;
}

export const CopyToClipboardIconButton: React.FC<CopyToClipboardIconButtonProps> = ({
  value,
  label = "Copy to clipboard",
  sx = {},
}) => {
  const [copied, setCopied] = useState(false);
  return (
    <Tooltip title={copied ? "Copied!" : label} placement="top">
      <IconButton
        size="small"
        aria-label={label}
        onClick={(e) => {
          e.stopPropagation();
          navigator.clipboard.writeText(value);
          setCopied(true);
          setTimeout(() => setCopied(false), 1200);
        }}
        sx={{ ml: 0.25, p: 0.25, width: 24, height: 24, ...sx }}
      >
        <ContentCopyIcon fontSize="inherit" sx={{ fontSize: 16 }} />
      </IconButton>
    </Tooltip>
  );
};
